module.exports = __webpack_public_path__ + "static/media/empty-state-history.81a6e572.png";